class AuditItem{
    constructor({userId, date=new Date()}){
        if(userId == null)
            throw new Error("Audit Item requires that a userId be set");
        this.userId = userId;
        this.date = date;
    }
}

export { AuditItem };